import React from 'react'
import { useTranslation } from 'react-i18next'

import { Header } from '../../../../../components/Header'
import { SearchField } from '../../../../../components/SearchField'

type Props = {
  search: string
  setSearch: (value: string) => void
}

export const Title: React.FC<Props> = ({ search, setSearch }) => {
  const { t } = useTranslation()

  const actions = (
    <SearchField
      searchValue={search}
      setSearchValue={setSearch}
      placeholder={t('ordersHistory.title.search.placeholder')}
    />
  )
  return <Header title={t('ordersHistory.title.title')} actions={actions} />
}
